<p-dialog [(visible)]="isVisible" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false"
    styleClass="onedrive-modal-dialog" (onHide)="closeModal()">

    <!-- Custom Header Template -->
    <ng-template pTemplate="header">
        <div class="modal-header">
            <h5 class="modal-title" id="googleDriveModalLabel">
                <img src="assets/img/onedrive.png" alt="Google Drive" width="48" height="40">
                Select File from OneDrive
            </h5>
        </div>

    </ng-template>

    <div class="onedrive-modal-content">

        <!-- Loading State -->
        <div *ngIf="isLoading" class="loading-container">
            <div class="loading-content">
                <i class="pi pi-spin pi-spinner loading-spinner"></i>
                <p class="loading-message">{{ loadingMessage }}</p>
            </div>
        </div>

        <!-- Main Content -->
        <div *ngIf="!isLoading" class="modal-body">

            <!-- OneDrive Info -->
            <div class="info-section">
                <div class="service-header">
                    <img src="assets/img/onedrive.png" alt="OneDrive" class="service-icon">
                    <div class="service-info">
                        <h6 class="service-title">OneDrive</h6>
                        <p class="service-description">Connect to OneDrive</p>
                        <p class="service-description">Sign in to access your files from Microsoft OneDrive</p>
                    </div>
                </div>
            </div>

            <!-- File Type Info -->
            <div class="file-info-section">
                <div class="supported-formats">
                    <!-- <small class="format-label">Supported formats:</small> -->
                    <small class="format-label">Supported format:</small>
                    <div class="format-badges">
                        <span class="format-badge">PDF</span>
                        <!-- <span class="format-badge">DOC</span>
            <span class="format-badge">DOCX</span> -->
                    </div>
                </div>
                <div class="size-limit">
                    <small class="size-label">Maximum file size: <strong>10 MB</strong></small>
                </div>
            </div>

            <!-- Instructions for OneDrive -->
            <div class="instructions-section">
                <div class="instruction-item">
                    <i class="pi pi-check-circle instruction-icon"></i>
                    <span>Click "Browse OneDrive" to authenticate</span>
                </div>
                <div class="instruction-item">
                    <i class="pi pi-check-circle instruction-icon"></i>
                    <span>Browse and select your PDF document</span>
                </div>
                <div class="instruction-item">
                    <i class="pi pi-check-circle instruction-icon"></i>
                    <span>Click the "Select" button</span>
                </div>
            </div>

            <!-- Error Display -->
            <div *ngIf="false" class="error-section">
                <div class="error-message">
                    <i class="pi pi-exclamation-triangle error-icon"></i>
                    <span>Error message would appear here</span>
                </div>
            </div>

        </div>
    </div>

    <!-- Footer -->
    <ng-template pTemplate="footer">
        <div class="modal-footer" style="border-top: 1px solid #e1e5e9;padding-top: 1rem;">
            <p-button label="Cancel" icon="pi pi-times" (onClick)="closeModal()" 
                >
            </p-button>

            <p-button label="Browse OneDrive" icon="pi pi-folder-open" (onClick)="openOneDrivePicker()">
            </p-button>
        </div>
    </ng-template>

</p-dialog>

<!-- Global Loading Overlay -->
<!-- <div *ngIf="isLoading" class="global-loading-overlay">
    <div class="loading-backdrop"></div>
</div> -->